<!--
  - Copyright (c) 2020.
  - Project: Source
  - LastModified: 2/14/20, 3:23 PM
  - Author: diengv < Giáp Văn Điện >
  - Email: diengv@ominext.com
  - File name: dashboard.vue
  - File path: D:/Projects/PMS/Source/Client/vuejs/src/resources/views/master/dashboard.vue
  -->

<template>
    <div>
      Trang tổng quan master
    </div>
</template>

<script>
  export default {
    name: 'dashboard'
  }
</script>

<style scoped>

</style>
